import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { Identifiable as Id, Optional } from '@mews/std';
import { keyBy } from './keyBy';
import { EnforceKeyableRecord } from './types';

type Identifiable = Id<PropertyKey>;
type EnforceKeyableIdRecord<T extends Identifiable> = EnforceKeyableRecord<T, 'id'>;

interface KeyByIdTyped<T extends Identifiable> {
    <D extends T>(data: NonEmptyArray<D>): EnforceKeyableIdRecord<T>;
    <D extends T>(data: Optional<Array<D>>): EnforceKeyableIdRecord<T> | {};
}

export function keyById<T extends Identifiable>(data: NonEmptyArray<T>): EnforceKeyableIdRecord<T>;
export function keyById<T extends Identifiable>(data: Optional<Array<T>>): EnforceKeyableIdRecord<T> | {};
export function keyById<T extends Identifiable>(): KeyByIdTyped<T>;

export function keyById<T extends Identifiable>(...args: [] | [NonEmptyArray<T> | Optional<Array<T>>]) {
    if (args.length === 0) {
        return (data: NonEmptyArray<T> | Optional<Array<T>>) => keyBy('id', data);
    }
    return keyBy('id', args[0]);
}
